import * as React from "react";
import Grid from '@material-ui/core/Grid';
import Loading, { LoadingInfo } from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import { DisplayLicence, apiGetLicences } from "common/api/members/licencess";
import SeznamPrispevkuItem, { PrispItem } from "./SeznamPrispevkuItem";


interface SeznamPrispevkuProps {
    items: PrispItem[];
}

class SeznamPrispevku extends React.PureComponent<SeznamPrispevkuProps> {

    render() {
        const { items } = this.props;

        return <Grid container direction="column" justify="flex-start" spacing={24}>

            {items.map(p => <Grid item key={p.rok}><SeznamPrispevkuItem item={p} /></Grid>)}
        </Grid>;
    }
}


export default SeznamPrispevku;
